module.exports = __webpack_public_path__ + "img/sas-logo.d6e12b5.png";